import { createFileRoute } from "@tanstack/react-router";
import { MessagesPage } from "@/pages/messages/MessagesPage";

export const Route = createFileRoute("/_app/messages")({ component: MessagesPage });
